
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Fäst',
	'find_label': 'Sök',
	'findCancelLabel': 'Avbryt',
	'sourcePaneLabel': 'Valda källor',
	'sourcePaneContentLabel': 'Välj en källa',
	'addDataDashboardCoachMarkContents': 'Dra data från datapanelen till kontrollpanelen.',
	'addDataStoryCoachMarkContents': 'Dra data från datapanelen till berättelsen.',
	'addDataCoachMarkTitle': 'Lägg till data',
	'selectSourcesText': 'Välj och lägg till en datakälla för att bygga %{app}.',
	'selectSourcesLabel': 'Välj en källa',
	'errorSourcesTitle': 'Det gick inte att läsa in dataträd',
	'errorLoadingDataSources': 'Fel vid inläsning av listan över datamängder.',
	'errorLoadingDataTree': 'Fel vid inläsning av trädet',
	'dataSetPaneLastUpdated': 'Uppdaterades senast: %{date}',
	'dataSourcePaneDateUnknown': 'Okänt',
	'moreTitle': 'Mer',
	'backLabel': 'Gå tillbaka',
	'addDataSourceDialogTitle': 'Lägg till en datakälla',
	'addDataSourceDialogButtonLabel': 'Lägg till',
	'dlg_use': 'Använd',
	'dlg_RelinkDataSourceTitle': 'Ersätt datamängden %{dataSourceName} med...',
	'propertiesDialogTitle': 'Egenskaper',
	'missingDataSetData': 'Data för den här datamängden är inte tillgängliga. Uppdatera datamängden eller be administratören om åtkomst till källan.',
	'errorLoadingSource': 'Metadata för \'%{sourceName}\' lästes inte in. KOntakta administratören för mer information.',
	'errorMessageTitle': 'Fel',
	'calculation_navigation_in_use': 'Borttagning av beräkningar eller navigeringsvägar ogiltigförklarar alla visualiseringar som refererar till det borttagna objektet. Vill du ta bort?',
	'delete_confirm': 'Bekräfta borttagning',
	'previewUnavailable': 'Datafack och globala filter är inte tillgängliga för den här pakettypen.',
	'contextualGridTabName': 'Visualiseringsdata',
	'DATA_TRAY_no_data_text': '\'Data visas här.\'',
	'contextualGridMenuLabel': 'Visualiseringsdatameny',
	'contextualGridExport': 'Exportera',
	'nullValueText': 'Null',
	'forecastDetailsTabName': 'Prognostiserar statistisk information',
	'forecastDetailsModelLabel': 'Modell',
	'forecastDetailsQualityMetricLabel': 'Noggrannhetsmått',
	'forecastDetailsSmoothingCoefLabel': 'Parametrar',
	'forecastDetailsDiagnostics': 'Felsökning',
	'forecastDetailsForecastLabel': 'Prognos',
	'forecastDetailsStatusLabel': 'Status',
	'forecastDetailsAccuracyPercentLabel': 'Precision %',
	'forecastDetailsTrendLabel': 'Trend',
	'forecastDetailsSeasonLabel': 'Säsong',
	'forecastDetailsSeasonalPeriodLabel': 'Säsongsperiod',
	'forecastDetailsAlphaLabel': 'Alfa',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gamma',
	'forecastDetailsPhiLabel': 'Pi',
	'forecastDetailsMissingCount': 'Felande antal',
	'forecastDetailsSeriesLengthLabel': 'Serielängd',
	'forecastDetailsIgnoredPeriods': 'Ignorerade perioder',
	'forecastDetailsTrendStrength': 'Trendstyrka',
	'forecastDetailsSeasonalityStrength': 'Säsongsstyrka',
	'forecastDetailsTimeDeltaUnit': 'Datum-/tidsintervall',
	'forecastDetailsNotes': 'Kommentarer'
});
